import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { default as React, useEffect, useState } from "react";
import Select from "react-select";
import "../Modal/Modal.css";
import {
  addHL7Node,
  getHL7Versions,
  updateHL7Node,
} from "../utilities/HL7utils";

const HL7NodeModal = (props) => {
  const { modalState, handleClose, setUpdate, title, edit, setFlag } = props;
  const styles = {
    modalStyles: {
      color: "white",
      position: "absolute",
      top: 0,
      right: 0,
      width: "30%",
      padding: "2rem",
      height: "100vh",
      backdropFilter: "blur(14.5px)",
      background: "transparent",
      boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
    },
    colors: {
      primary75: "white",
      primary50: "white",
      primary25: "white",
      danger: "#DE350B",
      dangerLight: "#FFBDAD",
      neutral0: "black",
      neutral5: "hsl(0, 0%, 95%)",
      neutral10: "hsl(0, 0%, 90%)",
      neutral20: "hsl(0, 0%, 80%)",
      neutral30: "hsl(0, 0%, 70%)",
      neutral40: "hsl(0, 0%, 60%)",
      neutral50: "hsl(0, 0%, 50%)",
      neutral60: "hsl(0, 0%, 40%)",
      neutral70: "hsl(0, 0%, 30%)",
      neutral80: "white",
      neutral90: "hsl(0, 0%, 10%)",
    },
    controlStyles: {
      width: "100%",
      backgroundColor: "#121C1B",
      color: "white",
      zIndex: 9999,
      border: "1px solid #0f9077",
      boxShadow: "0 0 1px rgba(0, 0, 0, 0)",
      "&:hover": {
        border: "1px solid #0f9077",
      },
    },
  };

  const [serverConfig, setServerConfig] = useState({});
  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [HL7Versions, setHL7Versions] = useState([]);
  const [version, setVersion] = useState(null);
  const [updatedConfig, setUpdatedConfig] = useState();

  const versionChange = (selectedOption) => {
    setVersion(selectedOption);
    setServerConfig((prevConfig) => ({
      ...prevConfig,
      version: selectedOption?.value || "",
    }));
    validate("version", selectedOption?.value || "");
  };

  useEffect(() => {
    setServerConfig({
      name: edit?.name,
      ip: edit?.ip,
      port: edit?.port,
    });
    setVersion({ label: edit?.version, value: edit?.version });
  }, [edit]);

  useEffect(() => {
    setUpdatedConfig({
      id: edit?.id,
      name: serverConfig?.name,
      ip: serverConfig?.ip,
      port: serverConfig?.port,
      version: version?.value,
    });
  }, [serverConfig, version]);

  useEffect(() => {
    const fetchHL7Versions = async () => {
      try {
        const data = await getHL7Versions();
        setHL7Versions(data?.version_list);
      } catch (error) {
        console.error(error);
      }
    };

    fetchHL7Versions();
  }, []);

  const dropdownOptions = HL7Versions?.map((option) => ({
    label: option,
    value: option,
  }));

  const validate = (name, value) => {
    let errorMsg = "";
    switch (name) {
      case "name":
        if (!/\S/.test(value)) errorMsg = "Name is required.";
        break;
      case "ip":
        const ipPattern =
          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        if (!ipPattern.test(value.trim())) errorMsg = "Invalid IP address.";
        break;
      case "port":
        const portNum = parseInt(value, 10);
        if (!portNum || portNum < 1 || portNum > 65535)
          errorMsg = "Port must be between 1 and 65535.";
        break;
      case "version":
        if (!value.trim()) errorMsg = "Version is required.";
        break;
      default:
        break;
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMsg,
    }));
    return errorMsg === "";
  };

  useEffect(() => {
    const noErrors = Object.values(errors).every((error) => error === "");
    const allFieldsFilled = ["name", "ip", "port"].every(
      (field) => serverConfig[field]
    );

    setIsFormValid(noErrors && allFieldsFilled && version?.label);
  }, [errors, serverConfig, version]);

  const fetchData = async (serverConfig) => {
    if (title.toLowerCase() === "edit") {
      try {
        const data = await updateHL7Node(updatedConfig);
        setFlag((state) => !state);
        setResponseData(data);
      } catch (error) {
        console.error(error);
      }
    } else {
      try {
        const data = await addHL7Node(serverConfig);
        setFlag((state) => !state);
        setResponseData(data);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleClick = () => {
    const isValidName = validate("name", serverConfig?.name?.trim());
    const isValidIp = validate("ip", serverConfig?.ip?.trim());
    const isValidPort = validate("port", serverConfig?.port);
    const isValidVersion = validate("version", version?.value.trim());

    if (isValidName && isValidIp && isValidPort && isValidVersion) {
      fetchData(serverConfig);
      setUpdate(true);
      handleClose();
    } else {
      console.log("Validation failed");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setServerConfig((prevConfig) => ({
      ...prevConfig,
      [name]: value.trim(),
    }));
    validate(name, value.trim());
  };

  return (
    <div>
      <Modal
        className="Backdrop"
        open={modalState}
        onClose={handleClose}
        sx={{ width: "300", background: "transparent" }}
      >
        <Box sx={styles.modalStyles}>
          <div className="d-flex justify-content-between ">
            <div className="h5 font-weight-bold mt-2">{title} HL7 Node</div>
            <div className=" ">
              <IconButton
                className="text-light"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div className="node-modal-inputs">
            <div>
              <div>
                <label className="label-fields font-weight-bold">Name:</label>
              </div>
              <div>
                <input
                  className="text-input-modal"
                  type="text"
                  name="name"
                  value={serverConfig?.name || ""}
                  onChange={handleChange}
                />
              </div>
              {errors.name && (
                <span className="errorStyles">{errors?.name}</span>
              )}
            </div>
            <div>
              <div>
                <label className="label-fields font-weight-bold">IP:</label>
              </div>
              <div>
                <input
                  className="text-input-modal"
                  type="text"
                  name="ip"
                  value={serverConfig?.ip || ""}
                  onChange={handleChange}
                />
              </div>
              {errors.ip && <span className="errorStyles">{errors?.ip}</span>}
            </div>
            <div>
              <div>
                <label className="label-fields font-weight-bold">Port:</label>
              </div>
              <div>
                <input
                  className="text-input-modal"
                  type="text"
                  name="port"
                  value={serverConfig?.port || ""}
                  onChange={handleChange}
                />
              </div>
              {errors.port && (
                <span className="errorStyles">{errors?.port}</span>
              )}
            </div>
            <div>
              <div>
                <label className="label-fields font-weight-bold">
                  Version:
                </label>
              </div>
              <Select
                placeholder="Select HL7 Version"
                name="version"
                options={dropdownOptions}
                onChange={versionChange}
                value={version}
                isClearable={true}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "5px",
                  colors: styles.colors,
                })}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    ...styles.controlStyles,
                  }),

                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: "black",
                    color: "white",
                  }),

                  singleValue: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                }}
              />
              {errors.version && (
                <span className="errorStyles">{errors?.version}</span>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="btn-class mt-3"
                type="submit"
                name="btn-click"
                onClick={handleClick}
                disabled={!isFormValid}
              >
                SUBMIT
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default HL7NodeModal;
